import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BusinesscoItem, LogisticService, OrderStatusItem, OrderTypeItem } from '@app/services/logistic.service';
import { OrderheadService, OrderHeadsGet, PortalUserItem, SellerItem } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-heads-filter',
    templateUrl: './order-heads-filter.component.html',
    styleUrls: ['./order-heads-filter.component.css'],
})
export class OrderHeadsFilterComponent implements OnChanges, OnInit {
    @Input()
    public get?: OrderHeadsGet;

    @Output()
    public getChange = new EventEmitter<OrderHeadsGet>();

    public change = new EventEmitter<{ colname_change: keyof OrderHeadsGet } & OrderHeadsGet>();

    public companies: BusinesscoItem[] = [];

    public orderTypes: OrderTypeItem[] = [];

    public orderStatuses: OrderStatusItem[] = [];

    public portalUsers: PortalUserItem[] = [];

    public sellers: SellerItem[] = [];

    constructor(
        private orderhead: OrderheadService,
        private logistic: LogisticService,
    ) {
        //
    }

    public async onBusinessCoChanged() {
        this.loadPortalUsers();
        this.loadSellers();
        this.getChange.emit(this.get);
    }

    private async loadCompanies() {
        this.companies = await this.logistic.getCompanies('1');
    }

    private async loadOrderTypes() {
        this.orderTypes = await this.logistic.getOrderTypes({ add_all: '1' });
    }

    private async loadOrderStatuses() {
        this.orderStatuses = await this.logistic.getOrderStatuses({ add_all: '1', add_include_active: '1' });
    }

    private async loadPortalUsers() {
        this.portalUsers = await this.orderhead.getPortalUsers({ add_all: '1', businessco_no: this.get?.businessco_no });
    }

    private async loadSellers() {
        this.sellers = await this.orderhead.getSellers({ add_all: '1', businessco_no: '' + this.get?.businessco_no !== '99999' ? this.get?.businessco_no : '0' });
    }
    private staticOnInit() {
        this.loadCompanies();
        this.loadOrderTypes();
        this.loadOrderStatuses();
    }

    private async init() {
        this.loadPortalUsers();
        this.loadSellers();
    }

    ngOnInit(): void {
        this.staticOnInit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['get']) {
            this.init();
            //
        }
    }
}
